import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useTranslation } from '@lt/localization';
import { isEmpty } from 'lodash';
import { getUpgradedFlight } from '../../../../../../store/selectors/extras';
import {
  getSelectedFlightData,
  getOriginalFlightId,
} from '../../../../../../store/selectors/order';
import FlightsPropTypes from '../../../../proptypes/flights';
import withMobile from '../../../../hocs/withMobile';

import UpgradeFlightItem from '../../../../components/Services/UpgradeFlightItem';
import UpgradeFlightItemMobile from '../../../../components/Services/UpgradeFlightItemMobile';

const UpgradeFlightClass = ({
  flightData,
  currentFlight,
  originalFlight,
  isMobile,
}) => {
  const { t } = useTranslation();
  const businessFlightData = originalFlight ? currentFlight : flightData;
  if (!businessFlightData || isEmpty(businessFlightData)) {
    return null;
  }
  const UpgradeItem = isMobile ? UpgradeFlightItemMobile : UpgradeFlightItem;
  return (
    <div>
      <h2 className="checkout-flights__title like-h2">
        {t('checkout.upgradeFlightClass.title')}
      </h2>
      <UpgradeItem businessFlightData={businessFlightData} />
    </div>
  );
};

UpgradeFlightClass.propTypes = {
  flightData: FlightsPropTypes.item,
  currentFlight: FlightsPropTypes.item.isRequired,
  // Идентификатор выбранного на первом шаге эконом-рейса
  originalFlight: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
};
UpgradeFlightClass.defaultProps = {
  flightData: null,
  originalFlight: null,
};

const mapStateToProps = (state) => ({
  flightData: getUpgradedFlight(state),
  currentFlight: getSelectedFlightData(state),
  originalFlight: getOriginalFlightId(state),
});

export default connect(mapStateToProps)(withMobile(UpgradeFlightClass));
